import React from 'react';
import { useTranslation } from 'react-i18next';
import CardBody from 'components/Card/CardBody';
import withStyles from '@material-ui/core/styles/withStyles';
import DashboardIcon from '@material-ui/icons/DeleteForever';
import { combineStyles } from 'helpers/helpers';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import FormControlStickyButton from 'components/FormControlStickyButton/FormControlStickyButton';
import CardWrapper from 'components/Card/CardWrapper';

import SummarySection from './components/SummarySection/SummarySection';
import SelectUserSection from './components/SelectUserSection/SelectUserSection';
import CopyPaymentLinkDialog from './components/CopyPaymentLinkDialog/CopyPaymentLinkDialog.jsx';
import DietConfigurationSection from './components/DietConfigurationSection/DietConfigurationSection';

const NewOrder = ({
  diets,
  history,
  classes,
  promoCode,
  paymentType,
  useMoneyBox,
  usePromoCode,
  isSubmitting,
  isMoreThanOneDiet,
  sendConfirmation,
  selectedCustomer,
  calendarSettings,
  isInvoiceIncluded,
  orderCost = {},
  paymentLink = '',
  pickUpPoints = [],
  deliveryTypes = [],
  paymentMethods = [],
  availableAddons = [],
  customerAddresses = [],
  customerInvoiceData = {},
  isCopyPaymentLinkDialogOpened = false,
  isAllowedEcoContainer = false,
  isAllowedPremium = false,
  isAllowedTestDays = false,
  useTestMode = false,
  brandInfo = {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  addDiet = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  removeDiet = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  updateDiet = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  getDietCost = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  handleSubmit = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  promiseOptions = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  setUseMoneyBox = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  setUsePromoCode = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  selectPromoCode = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  promisePromoCodes = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  selectPaymentType = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  selectCurrentUser = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  setSendConfirmation = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  setIsInvoiceIncluded = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  setCustomerInvoiceData = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  updateCustomerAddresses = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  setIsCopyPaymentLinkDialogOpened = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  setUseTestMode = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <>
      <CopyPaymentLinkDialog
        classes={classes}
        history={history}
        isOpened={isCopyPaymentLinkDialogOpened}
        paymentLink={paymentLink}
        setIsOpened={setIsCopyPaymentLinkDialogOpened}
      />
      <div>
        <h1>{t('orders.newOrderForm')}</h1>
        {/* CUSTOMER SECTION */}
        <CardWrapper title={t('orders.client', '$$1. Klient')}>
          <CardBody style={{ zIndex: 100 }}>
            <SelectUserSection
              classes={classes}
              promiseOptions={promiseOptions}
              selectedCustomer={selectedCustomer}
              selectCurrentUser={selectCurrentUser}
            />
          </CardBody>
        </CardWrapper>
        {selectedCustomer && (
          <>
            {/* DIET SECTION */}
            {diets.map((diet, index) => (
              <>
                <CardWrapper
                  title={
                    index > 0 ? (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <h2>
                            {`${index + 2}. ${t('orders.sections.diet', '')}`}
                          </h2>
                          <div
                            onClick={() => removeDiet(index)}
                            style={{ color: 'red', cursor: 'pointer' }}
                          >
                            <DashboardIcon />
                          </div>
                        </div>
                      </>
                    ) : (
                      <h2>
                        {`${index + 2}. ${t('orders.sections.diet', '')}`}
                      </h2>
                    )
                  }
                >
                  <CardBody>
                    <DietConfigurationSection
                      diet={diet}
                      brandInfo={brandInfo}
                      classes={classes}
                      dietCost={getDietCost(index)}
                      dietIndex={index}
                      updateDiet={updatedDiet => updateDiet(updatedDiet, index)}
                      pickUpPoints={pickUpPoints}
                      deliveryTypes={deliveryTypes}
                      availableAddons={availableAddons}
                      calendarSettings={calendarSettings}
                      selectedCustomer={selectedCustomer}
                      customerAddresses={customerAddresses}
                      updateCustomerAddresses={updateCustomerAddresses}
                      isAllowedEcoContainer={isAllowedEcoContainer}
                      isAllowedPremium={isAllowedPremium}
                      isAllowedTestDays={isAllowedTestDays}
                      useTestMode={useTestMode}
                      setUseTestMode={setUseTestMode}
                      isMoreThanOneDiet={isMoreThanOneDiet}
                    />
                  </CardBody>
                </CardWrapper>
              </>
            ))}
            {/* SUMMARY SECTION */}
            <CardWrapper
              title={`${diets.length + 2}. ${t(
                'orders.sections.summary',
                '$$Podsumowanie'
              )}`}
            >
              <CardBody>
                <SummarySection
                  diets={diets}
                  classes={classes}
                  promoCode={promoCode}
                  orderCost={orderCost}
                  paymentType={paymentType}
                  useMoneyBox={useMoneyBox}
                  usePromoCode={usePromoCode}
                  setUseMoneyBox={setUseMoneyBox}
                  paymentMethods={paymentMethods}
                  selectPromoCode={selectPromoCode}
                  setUsePromoCode={setUsePromoCode}
                  sendConfirmation={sendConfirmation}
                  selectPaymentType={selectPaymentType}
                  promisePromoCodes={promisePromoCodes}
                  isInvoiceIncluded={isInvoiceIncluded}
                  setSendConfirmation={setSendConfirmation}
                  customerInvoiceData={customerInvoiceData}
                  setIsInvoiceIncluded={setIsInvoiceIncluded}
                  setCustomerInvoiceData={setCustomerInvoiceData}
                />
              </CardBody>
            </CardWrapper>
            <FormControlStickyButton
              classes={classes}
              discardText={t('orders.cancelOrder')}
              submitText={t('orders.createNewOrder', 'Stwórz nowe zamówienie')}
              cancelPath="/admin/orders"
              submitDisabled={isSubmitting}
              handleSubmit={handleSubmit}
              customButtonsLeft={
                // eslint-disable-next-line no-negated-condition -- FIXME
                !useTestMode
                  ? [
                      {
                        label: t('orders.addDiet', 'Dodaj dietę +'),
                        style: { margin: '5px' },
                        className: classes.marginLeft,
                        onClick: addDiet,
                      },
                    ]
                  : []
              }
            />
          </>
        )}
      </div>
    </>
  );
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

export default withStyles(combinedStyles)(NewOrder);
